<template>
	<CharacteristicSelectInline
		:value="value"
		:characteristic-items="meta.businessModel"
		initial-show-all
		:nothing-allowed="{
			text: 'Nein'
		}"
		with-experience
		:experience-config="{
			title: 'Braucht man Erfahrung darin?',
			nothingAllowed: {
				enabled: false
			}
		}"
		suppress-items-info
		label-set="customer"
		experience-selection-dropdown
		:label-type="labelTypeJobProfile"
		@input="$emit('input', $event)"
	/>
</template>

<script>
import CharacteristicSelectInline from "@/vue/characteristic/SelectInline";
import {JOB_PROFILE} from "@/helper/characteristic/Label";

export default {

	components: {
		CharacteristicSelectInline,
	},

	props: {
		value: {
			type: Array,
			required: false,
		},
		meta: {
			type: Object,
			required: true,
		},
	},

	computed: {
		labelTypeJobProfile ()
		{
			return JOB_PROFILE;
		}
	}
}
</script>
